import AboutContents from './AboutContents';

export default AboutContents;
export * as AboutContentsStyles from './AboutContents.styles';
export * as AboutContentsTypes from './AboutContents.types';
